import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import { useRootStore } from '~/base/hooks/useRootStore';
import DateHelper from '~/helpers/DateHelper';
import { useMFSurveyFormContext } from '~/microfrontend/hooks/useMFSurveyFormContext';
import { SurveyFormWidget } from '~/widgets/survey/components/SurveyFormWidget';
import { SurveyResultsWidget } from '~/widgets/survey/components/SurveyResultsWidget';

export const Survey: React.FC = observer(() => {
  const { surveyStore } = useRootStore();

  const { showResults, cardHeader } = useMFSurveyFormContext();

  const { classes } = useStyles();

  const { t } = useTranslation('survey');

  // Effects

  // Handlers

  // Renders

  const renderSurvey = (showResults?: boolean) => {
    // Отображаем компонент пройденного опроса по статусу в основном приложении
    if (showResults) {
      return <SurveyResultsWidget />;
    }

    return <SurveyFormWidget />;
  };

  const renderItem = (label: string, value: string) => {
    return (
      <Grid container wrap="nowrap" spacing={2}>
        <Grid item xs="auto">
          <Typography variant="body2" color="text.disabled" width={100}>
            {label}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography variant="body2" color="text.secondary" width="max-content">
            {value}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderSurveyHeader = () => {
    // Шапка с отображением даты прохождения опроса и того, кто прошел ( дата и пользователь приходят в GetSurveyResults, вынести в род проект не получится )
    if (!cardHeader) {
      return null;
    }

    return (
      <Grid container p={2} alignItems="flex-start">
        <Grid item xs>
          <Typography variant="h6" flexGrow={1}>
            {t('surveyHeader.title')}
          </Typography>
        </Grid>
        {surveyStore.surveyResults && (
          <Grid item xs="auto">
            <Stack spacing={1}>
              {renderItem(
                t('surveyHeader.dateDealerNotesAdd'),
                DateHelper.formatWithParseISO(surveyStore.surveyResults?.dateDealerNotesAdd) ?? '-',
              )}
              {renderItem(
                t('surveyHeader.dealerNotesAddUserName'),
                surveyStore.surveyResults?.dealerNotesAddUserName ?? '-',
              )}
            </Stack>
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <Card elevation={0} className={classes.card}>
      {renderSurveyHeader()}
      <Box p={2}>{renderSurvey(showResults)}</Box>
    </Card>
  );
});

const useStyles = makeStyles()(() => ({
  card: {
    height: '100%',
    minHeight: 146,
  },
}));
